import React from 'react'
import {FormattedNumber} from 'react-intl'
import EmptyStar from '../../assets/icons/EmptyStar.svg'
import FullStar from '../../assets/icons/FullStar.svg'
import HalfStar from '../../assets/icons/HalfStar.svg'
import {maxStars} from '../../config/constants'
import {IStarsProps} from './Stars'
import styles from './Stars.scss'

const StarThumbnail = ({stars, total, starsOnly, hideTotal, isCar, isStation, ...props}: IStarsProps) => {
  stars = Math.max(0, Math.min(stars, maxStars))
  const fullStars = Math.floor(stars)
  const halfStars = (stars > fullStars + 0.2) ? 1 : 0
  const emptyStars = maxStars - fullStars - halfStars
  const starsPanel = <>
    {[...Array(fullStars).keys()].map(index => <FullStar key={index} className={['fa', isCar ? 'text-van' : isStation ? 'text-primary' : styles.starColor].join(' ')}/>)}
    {[...Array(halfStars).keys()].map(index => <HalfStar key={index} className={['fa', isCar ? 'text-van' : isStation ? 'text-primary' : styles.starColor].join(' ')}/>)}
    {[...Array(emptyStars).keys()].map(index => <EmptyStar key={index} className={['fa', isCar ? 'text-van' : isStation ? 'text-primary' : styles.starColor].join(' ')}/>)}
  </>
  return <div {...props}>
    {starsPanel}
    { !starsOnly
    && <div className={['d-inline-block ml-1', (isCar || isStation) && 'text-black'].join(' ')}>
      <FormattedNumber value={stars} minimumFractionDigits={1} maximumFractionDigits={1}/>
    </div>
    }
    { !starsOnly && !hideTotal
    && <span>({total || 0})</span>
    }
  </div>
}
StarThumbnail.displayName = 'StarThumbnail'
export default StarThumbnail
